import React, { useEffect, useState } from 'react';
import { Text } from './Text';

type Props = {
  targetIso?: string | null;
  label?: string;
};

function format(targetIso: string): string {
  const ms = new Date(targetIso).getTime() - Date.now();
  if (ms <= 0) return 'now';
  const total = Math.floor(ms / 1000);
  const days = Math.floor(total / 86400);
  const hours = Math.floor((total % 86400) / 3600);
  const minutes = Math.floor((total % 3600) / 60);
  const seconds = total % 60;
  if (days > 0) return `${days}d ${hours}h`;
  if (hours > 0) return `${hours}h ${pad(minutes)}m`;
  if (minutes > 0) return `${minutes}m ${pad(seconds)}s`;
  return `0m ${pad(seconds)}s`;
}

const pad = (n: number) => (n < 10 ? `0${n}` : `${n}`);

export const Countdown: React.FC<Props> = ({ targetIso, label = 'DUE IN' }) => {
  const [, tick] = useState(0);
  useEffect(() => {
    if (!targetIso) return;
    const id = setInterval(() => tick((n) => n + 1), 1000);
    return () => clearInterval(id);
  }, [targetIso]);

  return (
    <div className="text-center">
      <Text variant="label" color="secondary">
        {label}
      </Text>
      <Text variant="display" tabular className="mt-1">
        {targetIso ? format(targetIso) : 'Nothing scheduled'}
      </Text>
    </div>
  );
};
